import React from 'react';
import PropTypes from 'prop-types';

import CaregiverName from './caregiver_name/CaregiverName';

const CaregiverTitle = (props) => {
  const caregiverData = props.caregiverData;
  const caregiverBackend = props.caregiverBackend;

  return (
    <CaregiverName
      caregiverData={caregiverData}
      caregiverBackend={caregiverBackend}
    />
  );
};
CaregiverTitle.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};

export default React.memo(CaregiverTitle);
